import React, { useState } from "react";
import { Modal, Timeline, Form, Row, Col, notification } from "antd";
import TextBox from "../../../components/ReportFormGenerator/TextBox/TextBox";
import Button from "../../../components/ReportFormGenerator/Button/Button";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import moment from "moment";

const dummyData = [
  {
    dt: "2015-09-01 09:12:11",
    rmrk: "Create a services",
  },
  {
    dt: "2015-09-01 10:32:11",
    rmrk: "Solve initial network problems",
  },
  {
    dt: "2015-09-01 13:45:11",
    rmrk: "Technical testing",
  },
  {
    dt: "2015-09-01 17:11:11",
    rmrk: "Network problems being solved",
  },
];

function NotificationModal({ visible, setVisible, lid }) {
  const [form] = Form.useForm();

  const [timelineData, setTimelineData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: msg,
    });
  };

  const onFinish = (values) => {
    setLoading(true);
    values["dt"] = moment
      .utc()
      .add(5, "hours")
      .add(30, "minutes")
      .format("YYYY-MM-DD HH:mm:ss");

    let tempTimelineData = [...timelineData, values];

    liracrypt
      .patch("/linedash/tabs/andonbroadcast", {
        lid: lid,
        msg: tempTimelineData,
        icon:"fa-comment-o"
      })
      .then((res, req) => {
        
        setLoading(false);
        openNotificationWithIcon("success", res.data.message);
        setTimelineData(tempTimelineData);
        form.resetFields();
      })
      .catch((err) => {
        setLoading(false);
        openNotificationWithIcon("error", "Something went Wrong !");
      });
  };

  React.useEffect(() => {
    liracrypt
      .get("/linedash/tabs/andonbroadcast", { lid: lid })
      .then((res, req) => {
        
        setTimelineData(res.data.data.msg);
      })
      .catch((err) => {
        openNotificationWithIcon("error", "Something went Wrong !");
      });
  }, [visible]);

  return (
    <div>
      <Modal
        title="📢 Andon Broadcast"
        style={{ minWidth: "800px" }}
        open={visible}
        onCancel={() => setVisible(false)}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <>
          {timelineData ? (
            <Timeline
              mode={"left"}
              style={{
                color: "#fff",
                fontWeight: "600",
                paddingTop: "20px",
                paddingRight: "30px",
              }}
            >
              {timelineData.map((data, index) => {
                return (
                  <Timeline.Item label={data.dt}>
                    <div
                      style={{
                        // backgroundColor: "red",
                        display: "inline-block",
                        marginRight: "10px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#3b3b3b",
                          display: "flex",
                          justifyContent: "center",
                          padding: "6px",
                          alignItems: "center",
                          borderRadius: "5px",
                        }}
                      >
                        {data.icon ? (
                          <i
                            className={"fa " + data.icon}
                            //   style={{ marginRight: "10px" }}
                          />
                        ) : (
                          <i
                            className={"fa fa-envelope"}
                            //   style={{ marginRight: "10px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span>{data.msg}</span>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          ) : (
            <></>
          )}
        </>
        <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
          <div className="ThemeForm">
            <Form
              name="ReportForm"
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              colon={false}
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={24} justify={"center"}>
                <Col span={24}>
                  <TextBox
                    form={form}
                    type="textarea"
                    name="msg"
                    label="Add Comment"
                    required={true}
                    errorMessage="Please Enter Comments"
                    maxChar={400}
                    maxCharErrorMessage="Accepted only 400 Chars"
                  />
                </Col>
              </Row>
              <Row gutter={24} justify="center">
                <Col span={24}>
                  <Button
                    // marginLeft={"60px"}
                    form={form}
                    submitButtonText={"Add Comment"}
                    resetButton={true}
                    loading={loading}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default NotificationModal;
